import ClientDetail from "./ClientDetail";
import ClientAddress from "./ClientAddress";

export { ClientDetail, ClientAddress };
